import { Stage, IDP } from 'src/constants/constants';

export function getStage(): Stage {
  // prod will be replaced during deployment by Katal Deployment Lambda with appropriate stage value.
  const stage = process.env.NODE_ENV !== 'production' ? Stage.DEV : (`prod` as Stage);
  return stage;
}
